import SignalContent from "../signal_content";
import { RequestSignallampParamsMaker } from "./make_signallamp_request_params";
import axios from "axios";
import CognitoController from "../../../common/scripts/cognito_controller";

export async function getSignallampComponentSetting(self: SignalContent) {
  try {
    const userID: string = self.userID;
    await CognitoController.refreshToken();
    const requestParams: object = RequestSignallampParamsMaker.makeGetSignallampComponentSettingDataParams(
      self,
      userID,
    );
    const apiResponse: any = await axios(requestParams);
    // userIDとsignallamp_idが一致するものは必ず一意
    self.mstSignallampComponent = apiResponse.data.res.mst_signallamp_component_settings;
    // ユーザに紐づく認証情報を取得
    self.authStores = apiResponse.data.res.auth_stores;
    return apiResponse;
  } catch (e) {
    alert(self.$t("message.failedToRetrieveSettings"));
  }
}
